<template>
  <div>
    <div
      class="bottom-0 flex justify-center w-full fixed z-50 p-2 pointer-events-none"
      :class="{'hidden': popups.length < 1}"
    >
      <div class="relative max-w-md w-full grid grid-cols-1 pointer-events-auto">
        <popup
          class="row-start-1 col-start-1"
          v-for="popup in filteredPopups"
          :content="popup"
          :key="popup.id"
        />
        <div
          class="absolute top-0 left-0 -ml-2 -mt-2 w-8 h-8 bg-white border-2 border-black rounded-full text-black font-medium flex justify-center items-center text-center"
          v-if="openPopups"
        >{{ openPopups }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Popup from "@/modules/popups/components/Popup.vue";

export default {
  name: "Popups",
  data() {
    return {};
  },
  props: {},
  components: {
    Popup
  },
  methods: {},
  computed: {
    popups: function() {
      return this.$store.getters["popup/popups"];
    },
    filteredPopups() {
      return this.popups ? this.popups.slice(0, 1) : [];
    },
    openPopups() {
      let l = this.popups.length;
      return l > 10 ? "++" : l > 1 ? "+" + (l - 1) : false;
    }
  },
  created() {},
  watch: {
    popups(newVar) {}
  }
};
</script>
